module.exports = __webpack_public_path__ + "static/thomas-wolfe-7da7e0a9e7f18166ea227c61bbcd7a6b.jpg";